import { Money } from '../../core/model/money';

export class VatReportInvoice {
  constructor(model: any) {
    this.invoiceNumber = model.invoiceNumber;
    this.invoiceRecipient = model.invoiceRecipient;
    this.invoiceId = model.invoiceId;
    this.periodText = model.periodText;
    this.vatRealizedBeforePeriod = model.vatRealizedBeforePeriod;
    this.vatRealizedInPeriod = model.vatRealizedInPeriod;
    this.vatBasingRevenueInPeriod = model.vatBasingRevenueInPeriod;
    this.vatDueToRevenueInPeriod = model.vatDueToRevenueInPeriod;
    this.vatBasingRevenueAfterPeriod = model.vatBasingRevenueAfterPeriod;
    this.vatDueToRevenueAfterPeriod = model.vatDueToRevenueAfterPeriod;
    this.vatBasingRevenue = model.vatBasingRevenue;
    this.turnover25 = model.turnover25;
    this.turnover25Voluntary = model.turnover25Voluntary;
    this.turnover12 = model.turnover12;
    this.turnover12Voluntary = model.turnover12Voluntary;
    this.turnover6 = model.turnover6;
    this.turnover6Voluntary = model.turnover6Voluntary;
    this.turnoverNoVat = model.turnoverNoVat;
  }

  invoiceNumber: number;
  invoiceRecipient: string;
  invoiceId: string;
  periodText: string;
  vatRealizedBeforePeriod: Money;
  vatRealizedInPeriod: Money;
  vatBasingRevenueInPeriod: Money;
  vatDueToRevenueInPeriod: Money;
  vatBasingRevenueAfterPeriod: Money;
  vatDueToRevenueAfterPeriod: Money;
  vatBasingRevenue: Money;
  turnover25: Money;
  turnover25Voluntary: Money;
  turnover12: Money;
  turnover12Voluntary: Money;
  turnover6: Money;
  turnover6Voluntary: Money;
  turnoverNoVat: Money;
}

export class VatReport {
  constructor(model: any) {
    this.totalVatRealizedBeforePeriod = model.totalVatRealizedBeforePeriod;
    this.totalVatRealizedInPeriod = model.totalVatRealizedInPeriod;
    this.totalVatBasingRevenueInPeriod = model.totalVatBasingRevenueInPeriod;
    this.totalVatDueToRevenueInPeriod = model.totalVatDueToRevenueInPeriod;
    this.totalVatBasingRevenueAfterPeriod = model.totalVatBasingRevenueAfterPeriod;
    this.totalVatDueToRevenueAfterPeriod = model.totalVatDueToRevenueAfterPeriod;
    this.totalVatBasingRevenue = model.totalVatBasingRevenue;
    this.totalTurnover25 = model.totalTurnover25;
    this.totalTurnover25Voluntary = model.totalTurnover25Voluntary;
    this.totalTurnover12 = model.totalTurnover12;
    this.totalTurnover12Voluntary = model.totalTurnover12Voluntary;
    this.totalTurnover6 = model.totalTurnover6;
    this.totalTurnover6Voluntary = model.totalTurnover6Voluntary;
    this.totalTurnoverNoVat = model.totalTurnoverNoVat;
    this.vatPerInvoice = model.vatPerInvoice.map(i => new VatReportInvoice(i));
  }

  vatPerInvoice: VatReportInvoice[];

  totalVatRealizedBeforePeriod: Money;
  totalVatRealizedInPeriod: Money;
  totalVatBasingRevenueInPeriod: Money;
  totalVatDueToRevenueInPeriod: Money;
  totalVatBasingRevenueAfterPeriod: Money;
  totalVatDueToRevenueAfterPeriod: Money;
  totalVatBasingRevenue: Money;
  totalTurnover25: Money;
  totalTurnover25Voluntary: Money;
  totalTurnover12: Money;
  totalTurnover12Voluntary: Money;
  totalTurnover6: Money;
  totalTurnover6Voluntary: Money;
  totalTurnoverNoVat: Money;
}
